import React from "react";

import { NestedRoute } from "../../components/shared/NestedRoute/NestedRoute";

export const Manage = () => {
  return <NestedRoute baseRoute="manage-sidebar" />;
};
